import deApiLib from '@any2any/platform-api/i18n/de.json';
import enApiLib from '@any2any/platform-api/i18n/en.json';
import { _, commonLocaleConverter, LocalizationConfig } from '@any2any/shared';
import deApp from './core/data/i18n/de.json';
import enApp from './core/data/i18n/en.json';

export const appLocalization = new LocalizationConfig({
  en: {
    data: [enApiLib, enApp],
    label: _('admin.language_names.english')
  },
  de: {
    data: [deApiLib, deApp],
    label: _('admin.language_names.german')
  }
}, 'en', {
  reflectedLocaleConverter: commonLocaleConverter
});
